import { inject, Service, signal } from '@angular/core';
import { IAccess } from '../model/access';
import { IKiwidPermission } from '../model/kiwid-permissions';
import { BehaviorSubject } from 'rxjs';


export const hasPermission = (permissions: IKiwidPermission): boolean => {
    const kiwidPermissionsService = inject(KiwidPermissionsService);
    return kiwidPermissionsService.hasPermission(permissions);
}

@Service()
export class KiwidPermissionsService {
    public readonly permissions = signal<IAccess[]>([]);
    public readonly initialize = new BehaviorSubject<boolean>(false);

    constructor() {}

    setPermissions(permissions: IAccess[]) {
        this.permissions.set(permissions);
        this.initialize.next(true);
    }

    hasPermission(permissions: IKiwidPermission): boolean {
        if (!permissions || this.permissions().length === 0) {
            return false;
        }

        const permissionsList = this.permissions();

        if (!permissions.routeOperator || permissions.routeOperator === 'or') {
            return permissions.routeAccess.some((permission) => {
                const permissionFindModule = permissionsList.find((permissionList) => permission.mod === permissionList.module) ?? null;

                if (!permissionFindModule) {
                    return false;
                }

                if (!permission.opt || permission.opt === 'or') {
                    return permission.fns.some((fn) => permissionFindModule.functions[fn]);
                }

                return permission.fns.every((fn) => permissionFindModule.functions[fn]);
            });
        }

        return permissions.routeAccess.every((permission) => {
            const permissionFindModule = permissionsList.find((permissionList) => permission.mod === permissionList.module) ?? null;

            if (!permissionFindModule) {
                return false;
            }

            if (!permission.opt || permission.opt === 'or') {
                return permission.fns.some((fn) => permissionFindModule.functions[fn]);
            }

            return permission.fns.every((fn) => permissionFindModule.functions[fn]);
        });
    }
}
